import _ from 'lodash-es';

export default function () {
    const wasUserActive = useState('activityChecker.wasUserActive', () => false);
    const isUserActive = useState('activityChecker.isUserActive', () => false);

    const inactivityTimeout = ref(null);
    const inactivityTime = 1000;

    const resetActivityTimer = _.debounce(() => {
        wasUserActive.value = true;
        isUserActive.value = true;
        clearTimeout(inactivityTimeout.value);
        inactivityTimeout.value = setTimeout(() => {
            isUserActive.value = false;
        }, inactivityTime);
    }, 200, {
        leading: true,
        trailing: false
    });

    const setupActivityListeners = () => {
        const events = ["mousemove", "keydown", "touchstart", "touchmove", "scroll"];
        events.forEach((event) =>
            window.addEventListener(event, resetActivityTimer)
        );
    };

    const removeActivityListeners = () => {
        const events = ["mousemove", "keydown", "touchstart", "touchmove", "scroll"];
        events.forEach((event) =>
            window.removeEventListener(event, resetActivityTimer)
        );
    };

    onMounted(() => {
        setupActivityListeners();
    });

    onBeforeUnmount(() => {
        removeActivityListeners();
        clearTimeout(inactivityTimeout.value);
        resetActivityTimer.cancel();
    });

  return { wasUserActive, isUserActive };
}
